import { render, staticRenderFns } from "./CombinerData.vue?vue&type=template&id=72171322&scoped=true"
import script from "./CombinerData.vue?vue&type=script&lang=js"
export * from "./CombinerData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72171322",
  null
  
)

export default component.exports